import { render, staticRenderFns } from "./PracticePulseSkeleton.vue?vue&type=template&id=84ab62f4&scoped=true"
import script from "./PracticePulseSkeleton.vue?vue&type=script&lang=js"
export * from "./PracticePulseSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PracticePulseSkeleton.vue?vue&type=style&index=0&id=84ab62f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ab62f4",
  null
  
)

export default component.exports